import { HStack, Button } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { AgencyTypeGlobal } from '../../common/global-attributes';
import { agencyTypeDisplayNames } from '../../common/helpers/agency-type';
import { useOpenEventPanel } from '../use-open-event-panel';
import { useEventMetadataStore } from './event-metadata';

export const CrossClassLinks = observer(function CrossClassLinks(): React.ReactElement | null {
    const eventMetadata = useEventMetadataStore().state.metadata;
    const openEventPanel = useOpenEventPanel();
    if (!eventMetadata) {
        return null;
    }
    const currentClass = eventMetadata.agencyTypeGlobalAttrId;
    return (
        <HStack gridColumn="span 2">
            {eventMetadata.linkedAndCrossClassEvents
                .filter((linkedEvent) => linkedEvent.agencyTypeGlobalAttrId !== currentClass)
                .map((linkedEvent) => (
                    <Button
                        key={linkedEvent.id}
                        variant="ghost"
                        size="sm"
                        trailingVisual="OpenNewWindow"
                        onClick={() => {
                            setTimeout(() => {
                                openEventPanel({
                                    eventId: linkedEvent.id,
                                    shouldFocusPanel: true,
                                });
                            }, 0);
                        }}
                    >
                        {
                            agencyTypeDisplayNames[
                                linkedEvent.agencyTypeGlobalAttrId as AgencyTypeGlobal
                            ]
                        }
                    </Button>
                ))}
        </HStack>
    );
});
